<label *ngIf="label" [attr.for]="id"  class="block mb-2 ml-1" [ngClass]="{'ballot-summary-label': isFromBallotSummary, 'text-gray-900 body-small-regular': !isFromBallotSummary}" [id]="id + '-label'" >

  {{ label }}
</label>
<mat-form-field id="mat-form-field-{{id}}" class="date-picker" [ngClass]="{ 'default-class': !hasError && !isFocused, 'error-class': hasError, 'focused-class': !hasError && isFocused, 'date-picker-summary': isFromBallotSummary }" >

  <input matInput
                   [matDatepicker]="picker"
                   [id]="id + '-input'"
                   placeholder="{{placeholder}}"
                   [(ngModel)]="value"
                   (focus)="isFocused = true"
                   (blur)="isFocused = false"
                   [matDatepickerFilter]="dateFilter"
                   [disabled]="isDisabled"
                   [attr.displayDate]="getDisplayDate(value)"
                   readonly>

  <mat-datepicker-toggle matIconSuffix [for]="picker"  >
    <mat-icon matDatepickerToggleIcon>

      <span class="material-symbols-rounded icon-size">{{ calendar }}</span>
    </mat-icon>
  </mat-datepicker-toggle>

  <mat-datepicker #picker (opened)="isFocused = true" (closed)="isFocused = false"></mat-datepicker>

</mat-form-field>
<br>
<label *ngIf="errorMessage != ''" id="date-picker-error-message" class="relative text-red-400 body-default-regular bottom-5">{{errorMessage}}</label>

